import { Typography as MuiTypography } from "@mui/material";
import type { TypographyProps as MuiTypographyProps } from "@mui/material";
import type React from "react";

interface TypographyProps extends MuiTypographyProps {
    children: React.ReactNode;
}

export function Typography({ children, ...props }: TypographyProps) {
    return <MuiTypography {...props}>{children}</MuiTypography>;
}
